import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../basicElement/TableC';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';

const showTeacher = (key) => {
    return (text, record) => {
        const teacherName = record[`${key}TeacherName`] || '';
        let teacherCode = record[`${key}TeacherCode`];
        let isMain = record[`${key}IsMain`];
        teacherCode = teacherCode ? `[${teacherCode}]` : '';
        isMain = isMain ? `(主)` : '';
        return `${teacherName}${teacherCode}${isMain}`;
    };
};

class ChangeLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        const { record: { userId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.queryByUserId, {
            userId,
        }).then(res => {
            this.setState({
                data: res.data.changeLogList || [],
                loading: false,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => ([{
        title: '操作时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 80,
    }, {
        title: '变更前带教老师',
        dataIndex: 'beforeTeacherName',
        key: 'beforeTeacherName',
        width: 120,
        render: showTeacher('before')
    }, {
        title: '变更后带教老师',
        dataIndex: 'afterTeacherName',
        key: 'afterTeacherName',
        width: 120,
        render: showTeacher('after')
    }])

    render() {
        const { data, visible, loading, record } = this.state;
        const { userCompellation, employeeCode} = record;
        return (
            <Modal
                title="带教老师变更日志"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="600px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{ marginBottom: 16 }}>
                        被带教人员：{userCompellation}[{employeeCode}]
                    </div>
                    <TableC
                        data={data}
                        loading={loading}
                        columns={this.getColumns()}
                        className="quotationLog"
                    />
                </div>
            </Modal>
        );
    }
}

export default ChangeLog;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/Component/ChangeLog.js